import { BaseRepository } from "@/repositories/base-repository"
import { type IProjectGroup } from "@/interfaces/api/project-group.interface"

export class ProjectGroupRepository extends BaseRepository<IProjectGroup> {
  protected resourcePath = "core/project-groups"
}
